import { useTranslation } from 'react-i18next';

import type { BoardTheme } from './boardTheme';
import type { QmsDisplayWaitingPublic } from './types';

/**
 * The queue behind the now-serving tokens, in call order. Renders nothing
 * when the queue is empty; the next-up token is theme-highlighted.
 */
export function DisplayWaitingList({
  waiting,
  theme,
}: {
  waiting: QmsDisplayWaitingPublic[];
  theme: BoardTheme;
}): JSX.Element | null {
  const { t } = useTranslation('qms');
  if (waiting.length === 0) {
    return null;
  }
  return (
    <section data-testid="display-waiting">
      <h2
        className="mb-2 font-semibold uppercase tracking-[0.3em]"
        style={{ color: theme.labelAccent, fontSize: theme.labelFontSize }}
      >
        {t('displays.public.waiting')}
      </h2>
      <ul className="flex flex-col gap-2">
        {waiting.map((token) => (
          <li
            key={token.display_code}
            data-testid="display-waiting-token"
            data-display-code={token.display_code}
            className="rounded-md border px-4 py-3 font-mono text-xl font-bold tabular-nums"
            style={{
              backgroundColor:
                token.position === 1 ? theme.accentSoft : theme.surface,
              color: theme.accent,
              borderColor:
                token.position === 1 ? theme.accent : theme.border,
            }}
          >
            {token.display_code}
          </li>
        ))}
      </ul>
    </section>
  );
}
